import React from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import DisplayBox from "components/DisplayBox";
import Tags from "components/Tags";
import { css } from "@emotion/react";
import { SIZE, TYPE } from "components/Form";
import { MODAL_SIZE, withModalForm } from "components/Modal";
import { margins } from "style";
import { UPDATE_APPLICANT } from "graphql/mutations";
import { GET_APPLICATION_HIGHLIGHTS } from "graphql/queries/applicationHighlights";
import { TAG_COLORS } from "components/Tags/Tag";

/**
 * ApplicationHighlights
 *
 * @param {Object}  data
 * @param {Boolean} loading
 */
const ApplicationHighlights = ({ data, loading, ...props }) => (
  <DisplayBox
    numColumns={1}
    editButtonText={<FormattedMessage id="Missions.Applicants.ApplicationHighlights.EditButton.Text" />}
    loading={loading}
    parentKeyName="id"
    parentKeyValue={data?.id}
    updateId={data?.id}
    initialValues={{
      highlights: data?.highlights?.map((item) => ({
        name: item.name,
        id: item.id,
      })),
    }}
    data={[
      {
        body: <Tags data={data?.highlights} {...TAG_COLORS.green} />,
      },
    ]}
    isEmpty={!data?.highlights?.length && !loading}
    isEditable
    hideHeader
    {...props}
  />
);

const FORM_DATA = [
  {
    style: css`
      width: 100%;
    `,
    items: [
      {
        type: TYPE.tags,
        size: SIZE.xlarge,
        properties: {
          name: "highlights",
          placeholder: "Type a highlight...",
          queryName: GET_APPLICATION_HIGHLIGHTS,
          queryKeyName: "applicationHighlights",
          allowNew: true,
          autoFocus: true,
          required: false,
          minLength: 0,
          defaultOpen: true,
        },
      },
    ],
  },
];

const FORM_SETTINGS = {
  size: MODAL_SIZE.medium,
  data: FORM_DATA,
  title: <FormattedMessage id="Missions.Applicants.ApplicationHighlights.Form.Title" />,
  description: <FormattedMessage id="Missions.Applicants.ApplicationHighlights.Form.Description" />,
  marginSize: margins.xxsmall,
  mutationData: {
    mutationName: {
      update: UPDATE_APPLICANT,
      add: UPDATE_APPLICANT,
    },
  },
};

ApplicationHighlights.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withModalForm(ApplicationHighlights, FORM_SETTINGS);
